import React, { useEffect, useState } from "react";

import { DataTable } from "primereact/datatable";
import moment from "moment";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import useDebounce from "../../components/hooks/useDebounce";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import { toast } from "react-toastify";
import Dots from "../../../../assets/assests/detail.png";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Details from "./details_kiosk_usage";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";

const KioskUsageReport = ({ globalFilter, exportCSV, fromDate, toDate }) => {
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
 const [rowselect, setRowselect] = useState(null);
  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getReportData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/usage-report/get-all-paginated`,
        {
          params: {
            pageNumber,
            pageSize,
            searchTerm: debouncedSearch || "",
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getReportData(pageNumber, rows);
  };

  useEffect(() => {
    getReportData();
  }, [debouncedSearch, fromDate, toDate]);
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }
  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons">
       
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>

      </div>
    );
  };
  const columnsData = [
    // {
    //   field: "kioskId",
    //   header: "kiosk ID",
    //   body: (rowData) => rowData.kioskId || "--",
    // },
    {
      field: "kioskName",
      header: "kiosk Name",
      body: (rowData) => renderTextWithTooltip(rowData, "kioskName", "bottom"),
    },
    // {
    //   field: "kioskLocation",
    //   header: "kiosk Location",
    //   body: (rowData) => rowData.kioskLocation || "--",
    // },
    {
      field: "kioskBranch",
      header: "kiosk Branch",
      body: (rowData) => rowData.kioskBranch || "--",
    },
    {
      field: "userInteractions",
      header: "user Interactions",
      body: (rowData) => rowData.userInteractions || "--",
    },
    {
      field: "successfulTransactions",
      header: "successful (Trans)",
      body: (rowData) => rowData.successfulTransactions || "--",
    },
    {
      field: "failedTransactions",
      header: "failed (Trans)",
      body: (rowData) => rowData.failedTransactions || "--",
    },
    {
      field: "uptimeMinutes",
      header: "Uptime (min)",
      body: (rowData) => rowData.uptimeMinutes || "--",
    },
    {
      field: "downtimeMinutes",
      header: "downtime (min)",
      body: (rowData) => rowData.downtimeMinutes || "--",
    },
    {
      field: "uptimePercentage",
      header: "up time %",
      body: (rowData) => rowData.uptimePercentage || "--",
    },
    {
      field: "downtimePercentage",
      header: "down time %",
      body: (rowData) => rowData.downtimePercentage || "--",
    },
    // {
    //   field: "date",
    //   header: "Date",
    //   body: (rowData) =>
    //     rowData.date
    //       ? moment(rowData.date).format("YYYY-MM-DD HH:mm:ss")
    //       : "--",
    // },
    // {
    //   field: "createdDate",
    //   header: "Created Date",
    //   body: (rowData) =>
    //     rowData.createdDate
    //       ? moment(rowData.createdDate).format("YYYY-MM-DD HH:mm:ss")
    //       : "--",
    // },
    {
      field: "modifiedDate",
      header: "modified Date",
      body: (rowData) =>
        rowData.modifiedDate
          ? moment(rowData.modifiedDate).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];
 

  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/kiosks/usage-report/get-all`
      );
      exportToExcel(response.data.body, columnsData, "UsageReportData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);

  return (
    <>
       <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Kiosk Usage Report Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};

export default KioskUsageReport;
